import React, { Component } from "react";
import PropTypes from "prop-types";

import Loading from "@components/Loading";
import StoresRegionSelect from "@components/Stores/StoresRegionSelect";
import StoreCards from "@components/Stores/StoreCards";
import ErrorPage from "@containers/ErrorPage";

class RegionContainer extends Component {
  render() {
    const { stores, regions, currentRegion } = this.props;

    const regionStores =
      stores && stores.filter((store) => store.region_id === currentRegion.id);

    // Check store data
    if (!regions || !regionStores) {
      return <ErrorPage>Nu au fost gasite magazine</ErrorPage>;
    }

    return (
      <>
        <StoresRegionSelect
          regions={regions}
          currentRegion={currentRegion.url_key}
        />

        {stores ? (
          <StoreCards stores={regionStores} />
        ) : (
          <Loading height={150}>Se incarca lista magazinelor</Loading>
        )}
      </>
    );
  }
}

RegionContainer.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      address: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      phoneNumber: PropTypes.string,
      schedule: PropTypes.array,
    })
  ),
  regions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url_key: PropTypes.string.isRequired,
    })
  ),
  currentRegion: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    url_key: PropTypes.string.isRequired,
  }),
};

export default RegionContainer;
